<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chidruckmanjacobs0008#intro">Introduction</a></p>
<p class="tocpt"><a class="xref" href="#/chidruckmanjacobs0009#pt01"><span class="sm-b">PART</span> <span class="sm-b">I.</span> <b>Political Representation and Presidential Manipulation</b></a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0010#ch01"><span class="sm">CHAPTER</span> <span class="sm">1.</span>	Presidential Crafted Talk and Democratic Theory</a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0011#ch02"><span class="sm">CHAPTER</span> <span class="sm">2.</span>	The Political Strategy of Tracking the Public</a></p>
<p class="tocpt"><a class="xref" href="#/chidruckmanjacobs0012#pt02"><span class="sm-b">PART</span> <span class="sm-b">II.</span> <b>Presidential Strategies to Shape Public Opinion</b></a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0013#ch03"><span class="sm">CHAPTER</span> <span class="sm">3.</span>	How White House Strategy Drives the Collection and Use of Its Polling</a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0014#ch04"><span class="sm">CHAPTER</span> <span class="sm">4.</span>	Segmented Representation</a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0015#ch05"><span class="sm">CHAPTER</span> <span class="sm">5.</span>	Elite Strategies to Prime Issues and Image</a></p>
<p class="tocpt"><a class="xref" href="#/chidruckmanjacobs0016#pt03"><span class="sm-b">PART</span> <span class="sm-b">III.</span> <b>America’s Democratic Dilemmas</b></a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0017#ch06"><span class="sm">CHAPTER</span> <span class="sm">6.</span>	The Effects and Limits of Presidential Efforts to Move Public Opinion</a></p>
<p class="toc"><a class="xref" href="#/chidruckmanjacobs0018#ch07"><span class="sm">CHAPTER</span> <span class="sm">7.</span>	Rethinking Representation</a></p>
<p class="tocbm"><a class="xref" href="#/chidruckmanjacobs0019#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chidruckmanjacobs0020#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chidruckmanjacobs0021#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chidruckmanjacobs0022#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-druckman-jacobs-0007.vue?9131e106